'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hashSigns = require('./hashSigns');

var _hashSigns2 = _interopRequireDefault(_hashSigns);

var _regexSupplant = require('../lib/regexSupplant');

var _regexSupplant2 = _interopRequireDefault(_regexSupplant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

var endHashtagMatch = (0, _regexSupplant2.default)(/^(?:#{hashSigns}|:\/\/)/, { hashSigns: _hashSigns2.default });

exports.default = endHashtagMatch;
module.exports = exports['default'];